
import { computed, defineComponent, ref, onBeforeUnmount } from "vue";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"

export default defineComponent({
  name: "ModalEditarLubrificante",
  components: {
    Button
  },
  props: {
    fechaModal: Function,
    marcas: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
  },
  setup(props) {
    const emitter = useEmitter();
    const loadSalvar = ref(false);
    const spanWarning = ref(false);
    const imagem = ref<HTMLInputElement>();
    const marcasDeLubrificantes = computed(() => props.marcas);
    const lubForm: any = ref({
        id_lubrificante: null,
        marca: "",
        produto: "",
        viscosidade: "",
        tipo: "",
        combustivel: "",
        descricao: "",
        acea: "",
        api: "",
        ilsac: "",
        norma_bmw: "",
        norma_chrysler: "",
        norma_fiat: "",
        norma_ford: "",
        norma_gm: "",
        norma_jaguar_land_rover: "",
        norma_mercedes: "",
        norma_psa: "",
        norma_renault: "",
        norma_vw: "",
        imagem: "",
        correspondencia: ""
    });

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = lubForm.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        lubForm.value.imagem = file;
        lubForm.value.imagemPreview = buildImagePreview(file);
      }
    }

    // abre o modal preenchendo dados quando receber o evento
    const openHandler = (payload: any) => {
      if (!payload?.lub) return;
      lubForm.value = { ...payload.lub };
      lubForm.value.imagemPreview = buildImagePreview(lubForm.value.imagem);
    };

    const startHandler = () => {
      loadSalvar.value = true;
    };
    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      if (payload?.success) {
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("openEditLub", openHandler);
      emitter.on("addLub:start", startHandler);
      emitter.on("addLub:finish", finishHandler);
    }

    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("openEditLub", openHandler);
        emitter.off("addLub:start", startHandler);
        emitter.off("addLub:finish", finishHandler);
      }
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = null;
      }
    });

    // quando clicar salvar, emite para o pai
    async function onSave() {
      if (!lubForm.value.tipo || !lubForm.value.marca || !lubForm.value.viscosidade || !lubForm.value.produto) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;

      if (emitter && emitter.emit) {
        await emitter.emit("editLub", { lub: lubForm.value });
      }
      // não fecha aqui — Filtro controla fechamento quando receber finish
    }

    function openFileDialog() {
      imagem.value?.click();
    }

    return {
      lubForm,
      handleImgFileChange,
      onSave,
      loadSalvar,
      spanWarning,
      marcasDeLubrificantes,
      fileName,
      openFileDialog,
      imagem,
    };
  }
});
